export default {
  props: {
    userType: {
      type: Number,
      default: 1
    },
    basicInfo: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
    };
  }
};
